import React from "react";
import { waLink } from "../lib/site";

export const WhatsAppIcon = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
    <path d="M19.11 17.39c-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.14-.61.14-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.14-.42-2.17-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.41.12-.55.13-.13.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.27 0 1.34.98 2.64 1.11 2.82.14.18 1.92 2.93 4.66 4.11.65.28 1.16.45 1.55.58.65.21 1.24.18 1.71.11.52-.08 1.6-.65 1.83-1.28.23-.63.23-1.18.16-1.28-.07-.11-.25-.18-.52-.32zM16.02 5.33c-5.89 0-10.66 4.77-10.66 10.66 0 1.88.49 3.72 1.43 5.34l-1.51 5.5 5.65-1.48c1.57.86 3.34 1.31 5.1 1.31 5.89 0 10.66-4.77 10.66-10.66 0-2.85-1.11-5.53-3.13-7.55a10.61 10.61 0 0 0-7.54-3.12zm6.3 16.96a8.92 8.92 0 0 1-6.3 2.61c-1.55 0-3.07-.4-4.41-1.16l-.32-.19-3.35.88.89-3.27-.21-.34a8.86 8.86 0 0 1-1.36-4.74c0-4.92 4-8.92 8.92-8.92 2.38 0 4.62.93 6.3 2.61a8.85 8.85 0 0 1 2.62 6.31c0 4.92-4 8.92-8.92 8.92h.14z" />
  </svg>
);

export const FloatingWhatsApp = () => {
  return (
    <a
      data-testid="floating-whatsapp-button"
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="float-wa fixed z-50 bottom-6 left-6 sm:bottom-8 sm:left-8 inline-flex items-center justify-center w-14 h-14 rounded-full text-white"
      style={{ background: "var(--whatsapp)" }}
    >
      <WhatsAppIcon className="w-7 h-7" />
    </a>
  );
};

export const WhatsAppButton = ({
  children,
  variant = "dark",
  className = "",
  testId,
  prefilled,
}) => {
  const base =
    "inline-flex items-center gap-3 px-7 py-4 rounded-full text-[12px] sans tracking-luxe transition-all duration-500 ease-out";
  const styles =
    variant === "dark"
      ? "bg-[#111] text-white hover:bg-[#1c1c1c] hover:scale-[1.015]"
      : variant === "ghost"
      ? "border border-[#111] text-[#111] hover:bg-[#111] hover:text-white"
      : "bg-[#25d366] text-white hover:bg-[#128c7e]";

  return (
    <a
      data-testid={testId}
      href={waLink(prefilled)}
      target="_blank"
      rel="noopener noreferrer"
      className={`${base} ${styles} ${className}`}
    >
      <WhatsAppIcon className="w-4 h-4" />
      <span>{children}</span>
    </a>
  );
};
